import React from 'react';
import Icon from '../../../components/AppIcon';

const TutorialStep = ({ tutorial }) => {
  return (
    <div className="tutorial-step">
      <div className="flex items-start gap-6 mb-6">
        <div className="flex-shrink-0">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-violet-600 rounded-xl flex items-center justify-center shadow-warm-md">
            <Icon name={tutorial?.icon} size={32} className="text-white" />
          </div>
        </div>
        <div className="flex-1">
          <h2 className="text-h2 font-heading text-gray-900 mb-2">{tutorial?.title}</h2>
          <p className="text-lg text-gray-600">{tutorial?.description}</p>
        </div>
      </div>

      <div className="bg-gradient-to-r from-blue-50 to-violet-50 rounded-lg p-6 mb-6">
        <h3 className="text-h3 font-heading text-gray-900 mb-4">{tutorial?.content?.heading}</h3>
        <ul className="space-y-3">
          {tutorial?.content?.points?.map((point, index) => (
            <li key={index} className="flex items-start gap-3">
              <div className="flex-shrink-0 mt-1">
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                  <Icon name="check" size={14} className="text-white" />
                </div>
              </div>
              <span className="text-gray-700 leading-relaxed">{point}</span>
            </li>
          ))}
        </ul>
      </div>

      {tutorial?.content?.image && (
        <div className="flex justify-center mb-6">
          <div className="logo">
            <Icon name={tutorial?.content?.image} size={120} className="text-gray-400" />
          </div>
        </div>
      )}
    </div>
  );
};

export default TutorialStep;